import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalDailyCustomerP(props) {
  const dailyCustomerP = props.model;

  return (
    <Modal
      title="Cartera diaria"
      model={dailyCustomerP}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/daily-customer-portfolio"
    >
      <TextField
        label="Documento"
        fullWidth
        type="date"
        name="document_date"
        margin="normal"
        defaultValue={!!dailyCustomerP ? dailyCustomerP.document_date : ""}
        InputLabelProps={{
          shrink: true
        }}
        required
      />
    </Modal>
  );
}
